import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/pages/Layout/register'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/change_api_url/index',
      name: 'ChangeAPIUrl',
      component: () => import('@/pages/api/index')
    },
    { path: '/login', name: 'Login', component: () => import('@/pages/login') },
    {
      path: '/register/xingye',
      name: 'RegisterXinye',
      component: () => import('@/pages/register/person_xingye')
    },
    {
      path: '/register/tonglian',
      name: 'RegisterTonglian',
      component: () => import('@/pages/register/person_tonglian')
    },
    {
      path: '/register/person',
      name: 'RegisterPerson',
      component: () => import('@/pages/register/person')
    },
    {
      path: '/register/club',
      name: 'RegisterClub',
      component: () => import('@/pages/register/club')
    },
    {
      path: '/register/umpire',
      name: 'RegisterUmpire',
      component: () => import('@/pages/register/umpire')
    },
    {
      path: '/register/coach',
      name: 'RegisterCoach',
      component: () => import('@/pages/register/coach')
    },
    {
      path: '/bind/:userId/:openId',
      name: 'Bind',
      component: () => import('@/pages/home/bind')
    },
    {
      path: '/bind/success',
      name: 'BindSuccess',
      component: () => import('@/pages/home/bind_success')
    },
    {
      path: '/auth/:type/:userId/:openId',
      name: 'Auth',
      component: () => import('@/pages/Auth/index')
    },
      {
          path: '/direct/:token',
          name: 'Direct',
          component: () => import('@/pages/direct')
      },
      {
          path: '/directclub/:token',
          name: 'DirectClub',
          component: () => import('@/pages/direct_club')
      },
      {
          path: '/directcoach/:token',
          name: 'DirectCoach',
          component: () => import('@/pages/direct_coach')
      },
    {
      path: '/home',
      name: 'Layout',
      component: Layout,
      children: [
        {
          path: 'person/:id',
          name: 'HomePerson',
          component: () => import('@/pages/home/person')
        },
        {
          path: 'person/list/:id',
          name: 'HomePersonList',
          component: () => import('@/pages/home/person_list')
        },
        {
          path: 'club/:id',
          name: 'HomeClub',
          component: () => import('@/pages/home/club')
        },
        {
          path: 'club/list/:id',
          name: 'HomeClubList',
          component: () => import('@/pages/home/club_list')
        },
        {
          path: 'umpire/:id',
          name: 'HomeUmpire',
          component: () => import('@/pages/home/umpire')
        },
        {
          path: 'coach/:id',
          name: 'HomeCoach',
          component: () => import('@/pages/home/coach')
        }
      ]
    },
    {
      path: '/files/regulation',
      name: 'Regulation',
      component: () => import('@/pages/files/regulation')
    },
    { path: '/404', name: 'ErrorPage', component: () => import('@/pages/404') },
    { path: '/', redirect: '/login' },
    { path: '*', redirect: '/404' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js